import axios from "axios";
import _ from "lodash";
import {
  decryptAesObj,
  decryptAesObjNew,
  encryptAesObj,
  encryptAesObjwithTime,
} from "../components/CommonComponents/AESencryptdecrypt";
import config from "../config/config";
import { checkLoginTime } from "../components/RegenarateToekn";

export const userService = {
  get,
  GetWithoutEncrypt,
  post,
  put,
  deleteDetail,
  loginService,
  logoutService,
  postWithFile,
  postFIle,
  updateDistance,
  getTheAddress,
  newPost,
  newGet,
  newPostFIle,
};

// function updateDistance(apiEndpoint, payload, reset) {
//     debugger
//     console.log(apiEndpoint, payload, "updatedistance");
//     let datetime = new Date();
//     let dateslong = Date.parse(datetime);
//     // let enc = encryptAesObjwithTime(payload, dateslong); // removing ecryption
//     console.log(decryptAesObj(localStorage.getItem("data")).token);
//     let data = {
//     //   payload: enc,
//     };

//     return axios({
//       method: "post",
//       url: apiEndpoint,
//     //   data: data,
//       data:payload,
//     //   data: JSON.stringify( payload ) ,

//       headers: {
//         'Authorization': 'Bearer ' + decryptAesObj(localStorage.getItem('data')).token,
//             'userId':  `${decryptAesObj(localStorage.getItem('data')).id}__${decryptAesObj(localStorage.getItem('ipaddress'))}__${decryptAesObj(localStorage.getItem('data')).userType}`,
//             // "device":"ENCODED",// andriod means without encyption
//             "device":"ANDRIOD",// andriod means without encyption

//             // "timestamp":dateslong,
//         // Authorization:
//         //   "Bearer " + decryptAesObj(localStorage.getItem("data")).token,
//         //   accept: 'application/json',
//         // 'Accept': 'application/json',
//         // 'Content-Type': 'application/json' ,

//         //   "Content-Type": "multipart/form-data",
//         //   "Content-Type": "text",

//         //   'content-type': 'application/x-www-form-urlencoded',
//         // 'Content-Type':"application/json",
//         // device: "WEB",
//         timestamp: dateslong,
//       }
//     })
//       .then((response) => {
//         console.log("update distance ==", response);
//         console.log(decryptAesObjNew(response.data), "gagagagag");
//         reset();

//             alert("Distance Updated Successfully !");

//         return response;
//       })
//       .catch((err) => {
//         console.log(err);
//         return err.response;
//       });
//   }

async function updateDistance(apiEndpoint, payload, reset) {
  await checkLoginTime(
    new Date(),
    new Date(decryptAesObj(localStorage.getItem("lastUpdateTime")))
  );

  // console.log(apiEndpoint, payload, "updatedistance");
  let datetime = new Date();
  let dateslong = Date.parse(datetime);
  // let enc = encryptAesObjwithTime(payload, dateslong); // removing ecryption
  console.log(decryptAesObj(localStorage.getItem("data")).token);

  return axios({
    method: "post",
    url: apiEndpoint,
    // data: data,
    data: payload,

    headers: {
      Authorization:
        "Bearer " + decryptAesObj(localStorage.getItem("data")).token,
      //   "Content-Type": "multipart/form-data",
      device: "WEB",
      timestamp: dateslong,
    },
  })
    .then((response) => {
      console.log("update distance ==", response);
      console.log(decryptAesObjNew(response.data), "gagagagag");
      reset();
      alert("Distance Updated Successfully !");
      return response;
    })
    .catch((err) => {
      console.log(err);
      return err.response;
    });
}
// function updateDistance(apiEndpoint,payload,reset){
//     console.log(apiEndpoint,payload,"updatedistance")
//     let datetime=new Date()
//     let dateslong= Date.parse(datetime)
//     let enc =encryptAesObjwithTime(payload,dateslong)
//     console.log(decryptAesObj(localStorage.getItem('data')).token)
//     let data={
//         payload:enc
//     }
//     return axios({
//         method:'post',
//         url:apiEndpoint,
//         data:data,

//         headers:{
//             'Authorization': 'Bearer ' + decryptAesObj(localStorage.getItem('data')).token,
//             'device':'WEB',
//             'timestamp':dateslong
//         }
//     })
//         .then((response)=>{
//             console.log("update distance ==",response)
//             console.log(decryptAesObjNew(response.data),"gagagagag")
//             reset();
//             alert("Distance Updated Successfully !");
//             return response;

//         }).catch((err)=>{
//             console.log(err);
//             if(err.response!=undefined && err.response.status==401){
//                 window.open('/','_self');
//             }else{
//                 return err.response;

//             }

//         })

// }
function logoutService(apiEndpoint) {
  return axios({
    method: "post",
    url: apiEndpoint,
    headers: {
      Authorization:
        "Bearer " + decryptAesObj(localStorage.getItem("data")).token,
    },
  })
    .then((response) => {
      return;
    })
    .catch((error) => {
      console.log(error);
      return;
    });
}
// log in Api without Header
function loginService(apiEndpoint, payload) {
  let datetime = new Date();
  let dateslong = Date.parse(datetime);
  let enc = encryptAesObjwithTime(payload, dateslong);
  let data = {
    payload: enc,
  };
  console.log(apiEndpoint, payload);
  return axios({
    method: "post",
    url: apiEndpoint,
    data: data,
    headers: {
      userId: `__${decryptAesObj(localStorage.getItem("ipaddress"))}`,
      device: "WEB",
      timestamp: dateslong,
    },
  })
    .then((response) => {
      debugger;
      let res = decryptAesObjNew(response.data);
      console.log(res, apiEndpoint);
      response.data = res;

      return response;
    })
    .catch((err) => {
      console.log(err);
      return err.response;
    });
}

// get Api call common
async function get(apiEndpoint, payload) {
  await checkLoginTime(
    new Date(),
    new Date(decryptAesObj(localStorage.getItem("lastUpdateTime")))
  );
  return axios
    .get(apiEndpoint, getOptions())
    .then((response) => {
      // decryptAesObjNew(console.log(response))
      let res = decryptAesObjNew(response.data);
      console.log("res, apiEndpoint", res, apiEndpoint);
      response.data = res;
      return response;
    })
    .catch((err) => {
      console.log(err);

      if (err.response != undefined && err.response.status == 401) {
        window.open("/", "_self");
      } else {
      }
    });
}
// Common function for making GET API calls
async function GetWithoutEncrypt(apiEndpoint, userId) {
  try {
    // Check if the user is still logged in based on the time
    await checkLoginTime(
      new Date(), // current time
      new Date(decryptAesObj(localStorage.getItem("lastUpdateTime"))) // last login time
    );
    const response = await axios.get(apiEndpoint, getOptions());
    return response;
  } catch (err) {
    // Handle errors
    // If the error is a 401 (Unauthorized), redirect to the login page
    if (err.response && err.response.status === 401) {
      window.open("/", "_self");
    }
  }
}

// Post Api call common

async function post(apiEndpoint, payload, address) {
  if (
    apiEndpoint !==
    "https://djbstaging.watsoo.com/backend/api/v1/dashbord/vehicle/status"
  ) {
    await checkLoginTime(
      new Date(),
      new Date(decryptAesObj(localStorage.getItem("lastUpdateTime")))
    );
  }
  let datetime = new Date();
  let dateslong = Date.parse(datetime);
  let enc = encryptAesObjwithTime(payload, dateslong);

  let data = {
    payload: enc,
  };

  return axios
    .post(apiEndpoint, data, getOptions(false, dateslong))
    .then((response) => {
      let res = decryptAesObjNew(response.data);
      response.data = res;
      return response;
    })
    .catch((err) => {
      console.log(err);
      if (err.response != undefined && err.response.status == 401) {
        window.open("/", "_self");
      } else {
        return err.response;
      }
    });
}

// for formdata type request
async function postFIle(apiEndpoint, payload) {
  await checkLoginTime(
    new Date(),
    new Date(decryptAesObj(localStorage.getItem("lastUpdateTime")))
  );
  debugger;
  let datetime = new Date();
  let dateslong = Date.parse(datetime);
  let enc = encryptAesObjwithTime(payload, dateslong);

  let data = {
    payload: enc,
  };
  debugger;
  return axios
    .post(apiEndpoint, payload, getOptions(true, dateslong, "ENCODED"))
    .then((response) => {
      let res = decryptAesObjNew(response?.data);
      response.data = res;
      return response;
    })
    .catch((err) => {
      if (err.response != undefined && err.response.status == 401) {
        window.open("/", "_self");
      } else {
        return decryptAesObjNew(err?.response?.data);
      }
    });
}
// PUt Api call common

async function put(apiEndpoint, payload) {
  await checkLoginTime(
    new Date(),
    new Date(decryptAesObj(localStorage.getItem("lastUpdateTime")))
  );
  let datetime = new Date();
  let dateslong = Date.parse(datetime);
  let enc = encryptAesObjwithTime(payload, dateslong);

  let data = {
    payload: enc,
  };
  return axios
    .put(config.baseUrl + apiEndpoint, data, getOptions(false, dateslong))
    .then((response) => {
      let res = decryptAesObjNew(response.data);
      response.data = res;
      return response;
    })
    .catch((err) => {
      console.log(err);
      if (err.response != undefined && err.response.status == 401) {
        window.open("/", "_self");
      } else {
      }
    });
}

// delete Api call common

async function deleteDetail(apiEndpoint, payload) {
  await checkLoginTime(
    new Date(),
    new Date(decryptAesObj(localStorage.getItem("lastUpdateTime")))
  );
  return axios({
    method: "delete",
    url: apiEndpoint,
    headers: {
      Authorization:
        "Bearer " + decryptAesObj(localStorage.getItem("data")).token,
    },
  })
    .then((response) => {
      return response;
    })
    .catch((err) => {
      // window.open('/','_self');
    });
}

// Post Api call common

async function getTheAddress(apiEndpoint, payload) {
  await checkLoginTime(
    new Date(),
    new Date(decryptAesObj(localStorage.getItem("lastUpdateTime")))
  );

  return axios
    .post(apiEndpoint, payload, {
      Authorization:
        "Bearer " + decryptAesObj(localStorage.getItem("data")).token,
      userId: `${
        decryptAesObj(localStorage.getItem("data")).id
      }__${decryptAesObj(localStorage.getItem("ipaddress"))}__${
        decryptAesObj(localStorage.getItem("data")).userType
      }`,
    })
    .then((response) => {
      return response;
    })
    .catch((err) => {
      console.log(err);
      if (err.response != undefined && err.response.status == 401) {
        window.open("/", "_self");
      } else {
        return err.response;
      }
    });
}
function getOptions(type, time, str) {
  debugger;
  let options = {};
  if (decryptAesObj(localStorage.getItem("data")).token) {
    options.headers = {
      Authorization:
        "Bearer " + decryptAesObj(localStorage.getItem("data")).token,
      userId: `${
        decryptAesObj(localStorage.getItem("data")).id
      }__${decryptAesObj(localStorage.getItem("ipaddress"))}__${
        decryptAesObj(localStorage.getItem("data")).userType
      }`,
      device:
        type && str === "ENCODED"
          ? "ENCODED"
          : type && str == ""
          ? "ANDRIOD"
          : "WEB", // andriod means without encyption
      timestamp: time,
    };
  }

  return options;
}

async function postWithFile(apiEndpoint, payload) {
  await checkLoginTime(
    new Date(),
    new Date(decryptAesObj(localStorage.getItem("lastUpdateTime")))
  );
  var response = axios({
    method: "post",
    url: apiEndpoint,
    data: payload,
    headers: {
      Authorization:
        "Bearer " + decryptAesObj(localStorage.getItem("data")).token,
    },
  })
    .then(function (response) {
      //handle success
      let res = decryptAesObjNew(response.data);

      response.data = res;
      return response;
    })
    .catch(function (response) {
      //handle error
      console.log(response);
    });
  return response;
}

async function newPost(apiEndpoint, payload) {
  return axios
    .post(apiEndpoint, payload)
    .then((response) => {
      return response;
    })
    .catch((err) => {
      console.log(err);
      if (err?.response != undefined && err?.response?.status == 401) {
        window.open("/", "_self");
      } else {
        return err?.response;
      }
    });
}
async function newGet(apiEndpoint) {
  return axios
    .get(apiEndpoint)
    .then((response) => {
      console.log("resp123", response);

      return response;
    })
    .catch((err) => {
      console.log(err);
      if (err.response != undefined && err.response.status == 401) {
        window.open("/", "_self");
      } else {
        return err.response;
      }
    });
}

async function newPostFIle(apiEndpoint, payload) {
  return axios
    .post(apiEndpoint, payload)
    .then((response) => {
      return response;
    })

    .catch((err) => {
      console.log(err);
      if (err.response != undefined && err.response.status == 401) {
        window.open("/", "_self");
      } else {
        return err.response;
      }
    });
}
